module.exports = __webpack_public_path__ + "static/img/img_yewu5.dc8b300.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/img_yewu5.png
// module id = dHDJ
// module chunks = 1